import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Input, Spin } from "antd";
import moment from "moment";

import * as XLSX from "xlsx";

import { setLoading } from "../../../../redux/store/common/commonDuck";
import status from "../../../../utils/status";

const SellerExcelDownload = ({
  dataSource,
  targetYear,
  targetMonth,
  setExcelModalShow,
}) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [password, setPassword] = useState("");

  /**
   * 비밀번호 입력
   * @type {(function(*): void)|*}
   */
  const handlePasswordDownload = useCallback(
    (e) => {
      const { value } = e.target;
      setPassword(value);
    },
    [password],
  );

  /**
   * 비밀번호 확인 절차
   * @returns {function(): void}
   */
  const handleValidationPassword = () => {
    setIsLoading(true);
    let answer = "ekddud#@!7";
    if (password !== answer) {
      const timer = setTimeout(() => {
        setIsLoading(false);
        alert("정확한 비밀번호를 입력해주세요.");
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setDownloadLoading(true);
      const timer = setTimeout(() => {
        handleExcelDownloadClick();
      }, 300);
      return () => clearTimeout(timer);
    }
  };

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData;
      if (dataSource?.length !== 0) {
        excelData = dataSource?.map((row) => {
          let status =
            row.settlement_status === 0
              ? "정산요청"
              : row.settlement_status === 1 && !row.target_confirm
              ? "정산확인 대기중"
              : row.settlement_status === 2
              ? "정산확정"
              : "확정완료";
          return {
            seller_name: row.name, // 셀러명
            birthday: row.birthday, // 생년월일
            phone: row.phone, // 휴대폰
            settlement_month: moment(row.settlement_month).format("MM월"), // 정산월
            settlement_complete_date: row.settlement_complete_date
              ? moment(row.settlement_complete_date).format("YYYY.MM.DD")
              : moment(`${targetYear}.${targetMonth}.15`)
                  .add(1, "month")
                  .format("YYYY.MM.DD"), // 정산 완료일
            profit_price: row.expected_payment_amount ?? 0, // 정산 금액
            total_sales_price: row.total_purchase_amount ?? 0, // 판매 금액
            profit_amount: row.profit_amount ?? 0, // 수익 금액
            settlement_status: status, // 정산 상태
          };
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "정산 내역 및 목록");
      XLSX.writeFile(wb, `${targetYear}${targetMonth}_셀러정산.xlsx`);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("handleExcelDownloadClick edit error", error);
    }
    setIsLoading(false);
    setDownloadLoading(false);
    setExcelModalShow(false);
  };

  return (
    <div className={`excel-body`} style={{ gap: "1rem" }}>
      {isLoading && downloadLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            border: "solid 1px #ced4da",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "1em 1.5em",
            display: "flex",
            alignItems: "center",
            gap: "1em",
            boxShadow: "0 0px 6px 0 rgba(0, 0, 0, 0.16)",
            zIndex: 9,
          }}
        >
          <Spin style={{ lineHeight: 1 }} />
          <p style={{ margin: 0, whiteSpace: "pre-line" }}>
            엑셀을 내려받는 중입니다.
          </p>
        </div>
      )}
      <b>엑셀 다운로드 하기 위해서는 권한이 필요합니다.</b>
      <div className={`excel-file-upload-div`}>
        <div className={`excel-file-upload-each`}>
          <p className={`upload-title`}>비밀번호</p>
        </div>
        <div className={`excel-file-upload-each`}>
          <Input
            style={{
              width: "80%",
            }}
            type={"password"}
            id={"seller-excel-download"}
            onChange={handlePasswordDownload}
            value={password}
            onPressEnter={handleValidationPassword}
          />
          <Button
            className={`excel-file-select-btn`}
            style={{ marginLeft: "auto" }}
            onClick={handleValidationPassword}
            loading={isLoading}
          >
            확인
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SellerExcelDownload;
